'use strict';

import { App } from './App';
import { AppContainer } from 'react-hot-loader';
import React from 'react';
import ReactDom from 'react-dom';
import { LogProvider } from "./Providers/LogProvider";
import { LogSearch } from "./Search"; // Enable React devtools

window.React = React;
var logProvider = new LogProvider(50);

if (OCA.Search) {
  OCA.Search.logreader = new LogSearch(logProvider);
}

function render(App, rootElement) {
  ReactDom.render( /*#__PURE__*/React.createElement(AppContainer, null, /*#__PURE__*/React.createElement(App, {
    logProvider: logProvider,
    inlineSettings: rootElement.dataset.inlineSettings === 'true'
  })), rootElement);
}

$(document).ready(function () {
  var rootElement = document.getElementById('logreader-root');
  render(App, rootElement);

  if (module.hot) {
    module.hot.accept('./App', function () {
      var _require = require('./App'),
          NextApp = _require.App;

      render(NextApp, rootElement);
    });
  }
});